import debounce from './debouncer';

export interface ScrolledConfig {
	scrolledClass: string;
	scrolledDistanceClass: string;
	scrollDistanceDown: number;
	scrollDistanceUp: number;
}

/**
 * Adds config.scrolledClass to body if the page has been scrolled,
 * adds config.scrolledDistanceClass to body when scrolled down
 * by config.scrollDistanceDown and removes the same class when
 * scrolled back up by config.scrollDistanceUp
 */
export default class Scrolled {
	constructor(config: ScrolledConfig) {
		let triggerPoint = window.scrollY;

		const handleScroll = () => {
			if (config.scrolledClass !== undefined) {
				if (window.scrollY > 0) {
					document.body.classList.add(config.scrolledClass);
				} else {
					document.body.classList.remove(config.scrolledClass);
				}
			}

			if (config.scrolledDistanceClass !== undefined) {
				const diff = window.scrollY - triggerPoint;
				if (diff > 0 && diff >= config.scrollDistanceDown) {
					// Scroll down
					triggerPoint = window.scrollY;
					document.body.classList.add(config.scrolledDistanceClass);
				} else if (diff < 0 && 0 - diff >= config.scrollDistanceUp) {
					// Scroll up
					triggerPoint = window.scrollY;
					document.body.classList.remove(config.scrolledDistanceClass);
				}
			}
		};

		window.addEventListener('scroll', debounce(handleScroll));
		handleScroll();
	}
}
